<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogCategoryTree"
      persistent
      scrollable
      max-width="450px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Select Category</span>
        </v-card-title>
        <v-card-text>
          <template>
            <template>
              <v-treeview
                data-cy="treeviewCategory"
                v-if="categories != ''"
                class="treeviewClass"
                open-on-click
                rounded
                hoverable
                :items="categories"
                item-key="categoryid"
              >
                <template v-slot:prepend="{ item }">
                  <template>
                    <div class="radioBTN" v-if="item.categoryname != undefined">
                      <v-radio-group
                        v-model="radioGroup"
                        class="d-inline-block"
                      >
                        <v-radio
                          @click.stop="selectedCategory(item)"
                          :key="item.categoryid"
                          :value="item.categoryid"
                        ></v-radio>
                      </v-radio-group>
                      {{ item.categoryname }}
                    </div>
                  </template>
                </template>
              </v-treeview>
            </template>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeCateDialog()">
            close
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="SendCategory()"
            data-cy="selectCategory"
          >
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style >
.treeviewClass .v-input--selection-controls__ripple {
  height: 22px;
  width: 22px;
}
.radioBTN .v-icon.v-icon {
  font-size: 18px;
  top: 2px;
}

.treeviewClass .v-input--selection-controls__ripple {
  left: -6px;
  top: calc(50% - 16px);
}
.treeviewClass
  .v-treeview-node.v-treeview-node--rounded
  .v-treeview-node__root {
  height: 20px;
  margin: 0;
}
.treeviewClass .v-input--selection-controls {
  padding: 0;
}
.treeviewClass .v-input--selection-controls__input {
  margin-right: 2px;
  margin-left: -5px;
}
.treeviewClass .v-treeview-node {
  margin: -5px 0;
}
</style>


<script>
export default {
  props: ["dialogCategoryTree"],
  data() {
    return {
      categories: [
        {
          categoryid: null,
          categoryname: "Root",
          children: [],
        },
      ],
      radioGroup: null,
      SelectedCategory: {
        ID: "",
        Name: "",
      },
    };
  },

  mounted() {
    this.getTreeItems();
  },

  methods: {
    getTreeItems() {
      this.$store.dispatch("GetFromAPI", "/admin/category").then((response) => {
        this.categories[0]["children"] = response["data"]["data"];
      });
    },
    selectedCategory(item) {
      this.SelectedCategory.Name = item.categoryname;
      this.SelectedCategory.ID = item.categoryid;
    },
    SendCategory() {
      if (this.SelectedCategory.Name == "" || this.SelectedCategory.ID == "") {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      } else {
        this.$emit("SendCategoryValue", this.SelectedCategory);
      }
    },
    closeCateDialog() {
      this.$emit("closeCatDialog", false);
    },
  },
};
</script>
